export const GENDER_USER_OPTIONS = [
    {value: 1, label: "Male"}, 
    {value: 2, label: "Female"},
    {value:3, label: "Unknown"},
    {value:4, label: "Gay"},
    {value: 5, label: "Les"},
]